export enum AnalysisStatus {
    DRAFT = 'DRAFT',
    VALID = 'VALID',
    INVALID = 'INVALID'
}

const ANALYSIS_STATUS_PREFIX = 'ENUM.ANALYIS_STATUS.';

export function analysisStatusTranslationKey(status: AnalysisStatus | string | undefined): string {
    return ANALYSIS_STATUS_PREFIX + status;
}

export const analysisStatusTranslationKeys = Object.values(AnalysisStatus).reduce((translationKeys, status) => {
    translationKeys[status] = analysisStatusTranslationKey(status);
    return translationKeys;
}, {} as Record<AnalysisStatus, string>);
